<template>
  <div class="modal-mask" v-on:click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container" v-on:click.stop="">
        <div class="close-container">
          <button class="close-btn" v-on:click="$emit('close')">&times;</button>
        </div>
        <div class="modal-header">
          <slot name="header">
              
          </slot>
        </div>

        <div class="modal-body">
          <slot name="body">
              
          </slot>
        </div>

        <div class="modal-footer pr-0">
          <slot name="footer">
            
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {

      } 
    }
  }
</script>

<style scoped>
.modal-footer > * {
  margin: 0;
}
</style>
